import { getFeedbackCount } from '@bridebook/web/app-basic/lib/supplier/selectors';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import { useTranslation } from 'next-i18next';
import { Box, Slider } from '@bridebook/ui';
import SignupLink from '@bridebook/web/app-shared/components/signup-link/signup-link';
import { REVIEWS_PER_PAGE_LOGGED_OUT } from '@bridebook/web/app-shared/lib/supplier/constants';
import Pagination from '@bridebook/web/app-shared/components/pagination/pagination';
import AccordionCustom from '@bridebook/web/app-basic/components/supplier/sections/reviews/accordion-custom/accordion-custom';
import componentStyles from './venue-reviews.style';
import ReviewCard from './review-card';
import { UrlHelper } from '@bridebook/web/lib/url-helper';
import { useRouter } from 'next/router';
import type { Props as AliceCarouselProps } from 'react-alice-carousel/lib/types';
import screens from '@bridebook/ui/src/themes/variables/screens';
import { REVIEWS_SECTION_ID } from '@bridebook/web/app-shared/components/supplier/sections/ids';

const sliderProps: AliceCarouselProps = {
  infinite: false,
  responsive: {
    [screens.desktopSm]: {
      items: 2.3,
    },
    [screens.mobileSm]: {
      items: 1.2,
    },
  },
  autoWidth: false,
  disableButtonsControls: false,
  disableDotsControls: true,
};

const VenueReviews = () => {
  const { t } = useTranslation('supplier');
  const router = useRouter();

  const styles = componentStyles();

  const feedbackCount = useSelector(getFeedbackCount);
  const reviews = useSelector((state) => state.supplierDetails.reviews);

  const onPageSelect = () => {
    router.push(UrlHelper.signup);
  };

  const numberOfPages = Math.ceil(feedbackCount / REVIEWS_PER_PAGE_LOGGED_OUT);

  const paginatorPage = reviews.activePage - 1;

  if (!reviews?.feedback || reviews?.feedback?.length < 1) return null;

  return (
    <Box id={REVIEWS_SECTION_ID} style={styles.wrapper}>
      <Box style={styles.titleWrap}>
        <Box as="h5" style={styles.title}>
          {t('supplier.accordion.reviews.title')} ({feedbackCount})
        </Box>
        <AccordionCustom
          withAddReview={false}
          reviews={reviews}
          totalTestimonials={feedbackCount}
        />
      </Box>
      <Box style={styles.reviewsSlider}>
        <Slider
          showControlsOnHover
          sliderProps={sliderProps}
          items={reviews?.feedback?.map((review, index) => (
            <ReviewCard themeIndex={index % 3} key={review.id} review={review} />
          ))}
        />
      </Box>
      <SignupLink
        clickedSection="reviewsAndTestimonials"
        clickedLocation="supplierProfile"
        cta="reviewsAndTestimonials">
        <Pagination onSelect={onPageSelect} items={numberOfPages} activePage={paginatorPage} />
      </SignupLink>
    </Box>
  );
};

export default VenueReviews;
